import React from 'react';
import TopicLayout from '../Js_files/Topic_layout';
import Navbar from './Navbar';
import Footer from './Footer';
import { useEffect, useState } from 'react';
import EnrollForm from './Enroll';

const File1 = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showForm, setShowForm] = useState(false); // ✅ Control form visibility
  
  
           useEffect(() => {
          const handleScroll = () => {
            setShowScrollTop(window.scrollY > 200);
          };
          window.addEventListener('scroll', handleScroll);
          return () => window.removeEventListener('scroll', handleScroll);
        }, []);
      
        const scrollToTop = () => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        };
  const topics = [
    {
      title: "Thermodynamics",
      description: "Study of heat transfer, energy conversion, and thermal systems. Learn about the laws of thermodynamics and their applications in engines and power plants.",
      tags: ["Heat Transfer", "Energy", "Engines", "Power Systems"]
    },
    {
      title: "CAD & Design",
      description: "Computer-aided design tools and mechanical design principles. Master software like SolidWorks, AutoCAD, and learn design optimization techniques.",
      tags: ["SolidWorks", "AutoCAD", "3D Modeling", "Design"]
    },
    {
      title: "Manufacturing Processes",
      description: "Various manufacturing techniques including machining, casting, welding, and modern additive manufacturing processes.",
      tags: ["Machining", "Casting", "3D Printing", "Quality Control"]
    },
    {
      title: "Fluid Mechanics",
      description: "Study of fluid behavior, flow dynamics, and applications in hydraulic and pneumatic systems.",
      tags: ["Fluid Flow", "Hydraulics", "Pumps", "Turbines"]
    },
    {
      title: "Materials Science",
      description: "Properties and selection of engineering materials including metals, polymers, ceramics, and composites.",
      tags: ["Metals", "Polymers", "Testing", "Selection"]
    },
    {
      title: "Machine Design",
      description: "Design of mechanical components, mechanisms, and complete machine systems with focus on safety and efficiency.",
      tags: ["Gears", "Bearings", "Mechanisms", "Safety"]
    }
  ];

  const resources = [
    {
      icon: "📚",
      title: "Textbooks & References",
      description: "Comprehensive textbooks covering fundamental and advanced mechanical engineering concepts."
    },
    {
      icon: "🔧",
      title: "Software Tools",
      description: "Industry-standard CAD software, simulation tools, and engineering calculation programs."
    },
    {
      icon: "🏭",
      title: "Industry Projects",
      description: "Real-world case studies and projects from automotive, aerospace, and manufacturing industries."
    },
    {
      icon: "🎓",
      title: "Online Courses",
      description: "Structured learning paths and certification programs from leading educational platforms."
    }
  ];

  const careerPaths = [
    {
      title: "Design Engineer",
      description: "Create and develop mechanical systems, products, and components using CAD software and engineering principles.",
      skills: ["CAD Software", "Design Analysis", "Problem Solving", "Project Management"]
    },
    {
      title: "Manufacturing Engineer",
      description: "Optimize production processes, improve efficiency, and ensure quality in manufacturing operations.",
      skills: ["Process Optimization", "Quality Control", "Lean Manufacturing", "Automation"]
    },
    {
      title: "Automotive Engineer",
      description: "Design and develop vehicles, engines, and automotive systems for performance, safety, and efficiency.",
      skills: ["Vehicle Dynamics", "Engine Design", "Safety Systems", "Testing"]
    },
    {
      title: "Aerospace Engineer",
      description: "Work on aircraft, spacecraft, and related systems focusing on aerodynamics and propulsion.",
      skills: ["Aerodynamics", "Propulsion", "Materials", "Systems Integration"]
    }
  ];

  return (
    <>
    <Navbar onEnrollClick={() => setShowForm(true)}/>
    <TopicLayout
      title="Mechanical Engineering"
      icon="⚙️"
      color="#FF6B6B"
      description="Explore the world of mechanical systems, thermodynamics, and CAD tools. Discover real-world mechanical innovations, manufacturing processes, and the latest developments in automotive and aerospace engineering."
      topics={topics}
      resources={resources}
      careerPaths={careerPaths}
    />
    <Footer/>

      {/* Floating WhatsApp Icon */}
      <a
        href="https://wa.me/9042857947"
        className="floating-whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        title="Chat with us on WhatsApp"
      >
        <i className="fab fa-whatsapp"></i>
      </a>

      {/* Scroll to Top */}
      {showScrollTop && (
        <div className="scroll-to-top" onClick={scrollToTop} title="Scroll to top">
          <i className="fas fa-arrow-up"></i>
        </div>
      )}

      {/* ✅ Enroll Form Overlay */}
      {showForm && <EnrollForm onClose={() => setShowForm(false)} />}
    </>
  );
};

export default File1;